/**
 * @generated SignedSource<<c644e377939e71ee5c686fb49b7835f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponentVideo_viewer$data = {
  readonly muxMonitoringFF: boolean | null;
  readonly " $fragmentType": "HpSharedVideoComponentVideo_viewer";
};
export type HpSharedVideoComponentVideo_viewer$key = {
  readonly " $data"?: HpSharedVideoComponentVideo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentVideo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponentVideo_viewer",
  "selections": [
    {
      "alias": "muxMonitoringFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "muxMonitoring"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"muxMonitoring\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5c6dcc08ffc1d742b09ad293d92cc223";

export default node;
